/**
 * nin: loadLanguageOnPage decorator
 * 
 */
 import React, {Component} from "react";
 import {loadLanguage} from '../config/i18nConfiguration';
 import Utils from '../../common/Utils';
 import { Redirect } from 'react-router-dom';
 import _ from 'lodash';
import StorageHelper from "../StorageHelper";
 export default function loadLanguageOnPage() {  
     return function(Child) {
       return class extends Component {
          constructor(props) {
           super(props);
            this.pageLoadLang(this.updateLanguageParam(props.match.params.lang), false); 
          }
          render() {
             const sportsArr = _.split(
               this.removeLastSlash(
                 this.props.location.pathname
               ), '/');
             const lastUrlPath = sportsArr[sportsArr.length - 1];
             const atHomePage = lastUrlPath == 'asian';
             const arcadiaCookieSuffix = StorageHelper.getArcadiaSuffixCookieName();
             if((atHomePage || sportsArr.includes('sports')) && StorageHelper.getBrowsersStorage(arcadiaCookieSuffix)) {
              StorageHelper.removeBrowsersStorage(arcadiaCookieSuffix);
             }
             if(this.props.match.params.lang == null || this.props.match.params.lang === '') {               
                 let lang = Utils.getCurrentLang() || 'en'
 
                 return (
                     <Redirect to={`/${lang}/`} />
                 );
             }
             else{
                  return (
                     <Child {...this.props} />
                 )
           }
         }
         updateLanguageParam(lang) {
           const locale = Utils.toLocaleCode(lang, true);
           const __udata = Utils.getUdata();
           const userLang = Utils.getUserLanguage();
           // priority get userLang when refresh page
           const defaultLanguage = Utils.getDefaultLanguageByBrand(
             !window.env.isB2B && __udata.auth && userLang !== lang
               ? userLang
               : lang);
           // update to pathname
           if (lang !== defaultLanguage) {
             const path = this.props.location.pathname.replace(`/${lang}`, `/${defaultLanguage}`);
             this.props.history.push(path);
           }
           
           if (_.get(window.env, "langSupports", []).some(l => l === locale)) {
             return lang;
           }
           
           return defaultLanguage;
         }
         pageLoadLang(lang, isFireEvent) {
           if (lang === null) return

           loadLanguage(lang, isFireEvent);
           //this.state = { currentLang: lang };
           document.body.classList.add(Utils.toLocaleCode(lang));
           document.documentElement.classList.add(Utils.toLocaleCode(lang));

         }
         removeLastSlash(path) {
           return path.replace(/(\/*)$/, "");
         }
         componentWillUpdate(nextProps, nextState) {
             let nextLang = nextProps.match.params.lang;
             let currentLang = this.props.match.params.lang;
             if(currentLang !== nextLang){
                 this.pageLoadLang(nextLang, true);
                 document.body.classList.remove(Utils.toLocaleCode(currentLang)); 
                 document.documentElement.classList.remove(Utils.toLocaleCode(currentLang));              
             }
         }
 
         componentDidUpdate(prevProps, prevState) {
              //window.fireEvent(EVENT.BODY_CENTER_LOADING_DONE)
         }
         
      }
  }
 }


// WEBPACK FOOTER //
// ./src/app/common/decorator/loadLanguageOnPage.js